import { FC } from "react";

type Props = {
  className?: string;
};

const ArrowLeft_01_SharpIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="#2B2B2B"
      className={className}
    >
      <path
        d="M11 6L7.70711 9.29289C7.37377 9.62623 7.20711 9.79289 7.20711 10C7.20711 10.2071 7.37377 10.3738 7.70711 10.7071L11 14"
        stroke="inherit"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowLeft_01_SharpIcon;
